import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfSrc = '';
  title = '';


  constructor(
    private loader: LoaderService,
    public modal: NgbActiveModal
  ) {
    this.loader.show();
  }

  ngOnInit() {
  }

  loaded(e) {
    this.loader.clear();
  }
}
